import { EventEmitter, Injectable } from '@angular/core';
import { MenuModel } from '@bo-client/core/navigation/menu.model';
import { AuthenticationService } from '@bo-client/core';
import { ConfigService } from '@bo-client/config/config.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { SideMenuNode } from '@bo-client/core/navigation/main-menu.definition';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private _changedLoginState = new EventEmitter<any>();
  private companyLocations: CompanyLocationDto[];

  constructor(
    private authorizationService: AuthorizationService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private dataShareService: DataShareService
  ) {}

  generateMenu(menu: MenuModel[]): MenuModel[] {
    if (this.authenticationService.isLoggedIn) {
      menu = menu.filter(
        (ele) =>
          (this.authorizationService.hasPermission(ele.permission) ||
            this.authorizationService.hasOneOfThisRoles(ele.roles) ||
            (!ele.permission && (!ele.roles || ele.roles.length === 0))) &&
          (!ele.feature || this.configService.getSettings<any>('features')[ele.feature]) &&
          this.hasAreaType(ele)
      );
      return menu;
    }
    return [];
  }

  generateTreeMenu(menu: SideMenuNode[]): SideMenuNode[] {
    return menu
      .filter((item) => this.shouldShowMenuItem(item))
      .map((item) => {
        item = Object.assign({}, item);
        if (item.children) {
          item.children = this.generateTreeMenu(item.children);
        }
        return item;
      });
  }

  hasAreaType(menu: MenuModel): boolean {
    const areaList: AreaTypeEnum[] = menu.areaTypes;
    if (!areaList) {
      return true;
    }
    if (!this.companyLocations || this.companyLocations.length === 0) {
      return false;
    }
    return (
      this.companyLocations.find((x) => x.areatypes.find((y) => areaList.includes(AreaTypeEnum[y.name]))) !=
      undefined
    );
  }

  get notifyLoginChanged(): EventEmitter<any> {
    return this._changedLoginState;
  }

  shouldShowMenuItem(object: SideMenuNode): boolean {
    let disabledByTenantConfig: boolean = false;
    if (object.tenantConfig && this.dataShareService.tenantConfig) {
      disabledByTenantConfig = !object.tenantConfig.split('.').reduce((acc, key) => {
        return acc?.[key];
      }, this.dataShareService.tenantConfig);
    }
    return (
      !disabledByTenantConfig &&
      (this.authorizationService.hasPermission(object.permission) ||
        this.authorizationService.hasOneOfThisRoles(object.roles) ||
        (!object.permission && (!object.roles || object.roles.length == 0))) &&
      (!object.feature || this.configService.getSettings<any>('features')[object.feature]) &&
      (!object.uiAdaption ||
        !this.dataShareService.uiAdaptions.some((x) => {
          return x.anchor == object.uiAdaption && x.visibility == 'hide';
        }))
    );
  }
}
